<div class="h-100 d-flex align-items-center justify-content-center text-lg">
    <app-spinner></app-spinner> {{ "AUTHENTICATION.LOGOUT_IN_PROGRESS" | translate }}
</div>
